import React, { useState, useEffect, useRef } from 'react';
import {
    connect,
    useDispatch,
    //  useSelector
} from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useForm } from '@mantine/form';
import { TextInput, Button, Select } from '@mantine/core';
import ReCAPTCHA from 'react-google-recaptcha';
import { HiChevronDown } from 'react-icons/hi2';
import { FormattedMessage } from 'react-intl';
import {
    getData,
    postData,
} from '../../services/fetch-service';
import { updateTable } from '../../redux/TableSearch/dataSlice';

function SearchSlide(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const url = useLocation();
    const { location, locale } = props;
    const [aktivitetet, setAktivitetet] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const reCaptchaRef = useRef(null);

    useEffect(() => {
        getData(`Services/GetListaAktivitetet?Gjuha=${locale}`).then((response) => {
            setAktivitetet(response.data);
        });
    }, []);

    const AktivitetetSelect = aktivitetet.map((aktivitetet) => ({
        value: aktivitetet.NaceID,
        label: aktivitetet.Pershkrimi,
    }));

    // let placeholderText;
    let placeholderTextDropdown;
    let placeholderTextBusinessName;
    let placeholderTextNuid;
    let placeholderTextFiscalNr;
    let placeholderTextIdOwner;
    let gjuhaId = '';
    let token = null;

    if (locale === 'sq') {
        gjuhaId = '1'
        // placeholderText = 'Kërko';
        placeholderTextDropdown = 'Zgjedhe';
        placeholderTextBusinessName = 'Emri i Biznesit';
        placeholderTextNuid = 'Numri Unik Identifikues';
        placeholderTextFiscalNr = 'Numri Fiskal';
        placeholderTextIdOwner = 'ID e Pronarit / Autorizuesit';
    } else if (locale === 'en') {
        gjuhaId = '2'
        // placeholderText = 'Search';
        placeholderTextDropdown = 'Select';
        placeholderTextBusinessName = 'Business Name';
        placeholderTextNuid = 'Unique Identification Number';
        placeholderTextFiscalNr = 'Fiscal Number';
        placeholderTextIdOwner = 'Owner`s / Authorizer`s ID';
    } else if (locale === 'sr') {
        gjuhaId = '3'
        // placeholderText = 'Pretraga';
        placeholderTextDropdown = 'Izaberite';
        placeholderTextBusinessName = 'Naziv Biznisa';
        placeholderTextNuid = 'Jedinstveni matični broj';
        placeholderTextFiscalNr = 'Fiskalni Broj';
        placeholderTextIdOwner = 'ID Vlasnika / Ovlaštenika';
    }

    const form = useForm({
        initialValues: {
            emriBiznesit: '',
            nui: '',
            nrFiscal: '',
            numriPersonal: '',
            aktivitetiKryesorId: '',
            aktivitetetTjeraId: '',
            // gjuhaId: `${gjuhaId}`,
        },
        validate: (values) => {
            const areAllEmpty = Object.values(values).every((value) => value === '' || value === null);
            if (areAllEmpty) {
                return {
                    emriBiznesit: 'Please fill in at least one input',
                    nui: 'Please fill in at least one input',
                    nrFiscal: 'Please fill in at least one input',
                    numriPersonal: 'Please fill in at least one input',
                    aktivitetiKryesorId: 'Please fill in at least one input',
                    aktivitetetTjeraId: 'Please fill in at least one input',
                    // gjuhaId: 'Please fill in at least one input',
                };
            }
            return 'Form is valid';
        },
    });

    useEffect(() => {
        if (url.pathname !== '/TableSearch' && !url.pathname.startsWith('/TableDetails')) {
            form.setValues({
                emriBiznesit: '',
                nui: '',
                nrFiscal: '',
                numriPersonal: '',
                aktivitetiKryesorId: '',
                aktivitetetTjeraId: '',
            });
        }
    }, [url]);

    // const paramsId = useSelector((state) => state.tableSearch.tableDetailsID);

    // useEffect(() => {
    //     const resetAndDispatchToken = async () => {
    //         reCaptchaRef.current.reset();

    //         const token = await reCaptchaRef.current.executeAsync();

    //         dispatch(setToken(token));
    //     };

    //     resetAndDispatchToken();
    // }, [paramsId]);

    async function handleSubmit(event) {
        event.preventDefault();
        const validationResult = form.validate();

        reCaptchaRef.current.reset();

        if (validationResult.hasErrors === false) {
            token = await reCaptchaRef.current.executeAsync();
            try {
                setIsLoading(true);
                const values = { ...form.values, gjuhaId, token };

                if (values.aktivitetiKryesorId === null) {
                    values.aktivitetiKryesorId = '';
                }

                if (values.aktivitetetTjeraId === null) {
                    values.aktivitetetTjeraId = '';
                }

                const response = await postData('Services/KerkoBiznesin', values);
                setIsLoading(false);
                dispatch(updateTable(response.data));
                history.push('/TableSearch');
                // reCaptchaRef.current.reset();
                // token = await reCaptchaRef.current.executeAsync();
                // dispatch(setToken(token));
            } catch (error) {
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        } else {
            setIsLoading(false);
        }
    }

    let searchBox

    if (location === 'home') {
        searchBox = (
            <form className="search-labels" onSubmit={handleSubmit}>
                <div className="business-name">
                    <TextInput
                        label={<FormattedMessage id="NameBusiness" defaultMessage="Emri i Biznesit" />}
                        placeholder={placeholderTextBusinessName}
                        {...form.getInputProps('emriBiznesit', {
                            error: form.errors.search && form.touched.search,
                            errorLabel: form.errors.search,
                        })}
                    />
                </div>
                <div className="inputs-2">
                    <TextInput
                        mt="sm"
                        label={<FormattedMessage id="NUID" defaultMessage="Numri Unik Identifikues" />}
                        placeholder={placeholderTextNuid}
                        {...form.getInputProps('nui', {
                            error: form.errors.search && form.touched.search,
                            errorLabel: form.errors.search,
                        })}
                    />
                    <TextInput
                        mt="sm"
                        label={<FormattedMessage id="NrFiscal" defaultMessage="Numri Fiskal" />}
                        placeholder={placeholderTextFiscalNr}
                        {...form.getInputProps('nrFiscal', {
                            error: form.errors.search && form.touched.search,
                            errorLabel: form.errors.search,
                        })}
                    />
                    <TextInput
                        mt="sm"
                        className="id-pronarit"
                        label={<FormattedMessage id="IdOwner" defaultMessage="ID  e Pronarit / Autorizuesit" />}
                        placeholder={placeholderTextIdOwner}
                        {...form.getInputProps('numriPersonal', {
                            error: form.errors.search && form.touched.search,
                            errorLabel: form.errors.search,
                        })}
                    />
                </div>
                <div className="select-inputs">
                    <Select
                        label={<FormattedMessage id="MainActivity" defaultMessage="Aktiviteti Kryesor" />}
                        placeholder={placeholderTextDropdown}
                        searchable
                        clearable
                        allowDeselect
                        rightSection={
                            form.values.aktivitetiKryesorId ? (
                                ''
                            ) : (
                                <HiChevronDown size="1rem" />
                            )
                        }
                        rightSectionWidth={30}
                        {...form.getInputProps('aktivitetiKryesorId', {
                            error: form.errors.search && form.touched.search,
                            errorLabel: form.errors.search,
                        })}
                        styles={{ rightSection: { pointerEvents: 'none' } }}
                        data={AktivitetetSelect}
                    />
                    <Select
                        label={<FormattedMessage id="OtherActivity" defaultMessage="Aktivitet Tjera" />}
                        placeholder={placeholderTextDropdown}
                        searchable
                        clearable
                        allowDeselect
                        rightSection={
                            form.values.aktivitetetTjeraId ? (
                                ''
                            ) : (
                                <HiChevronDown size="1rem" />
                            )
                        }
                        rightSectionWidth={30}
                        {...form.getInputProps('aktivitetetTjeraId', {
                            error: form.errors.search && form.touched.search,
                            errorLabel: form.errors.search,
                        })}
                        styles={{ rightSection: { pointerEvents: 'none' } }}
                        data={AktivitetetSelect}
                    />
                </div>
                <Button className="btn-search-slide" type="submit" mt="sm" loading={isLoading}>
                    <FormattedMessage id="Search.name" defaultMessage="Kërko" />
                </Button>
            </form>
        )
    } else if (location === 'page') {
        searchBox = (
            <form className="search-labels" onSubmit={handleSubmit}>
                <div className="inputs-1">
                    <TextInput label={<FormattedMessage id="NameBusiness" defaultMessage="Emri i Biznesit" />} className="business-input" placeholder={placeholderTextBusinessName} {...form.getInputProps('emriBiznesit')} />
                    <TextInput mt="sm" label={<FormattedMessage id="NUID" defaultMessage="Numri Unik Identifikues" />} placeholder={placeholderTextNuid} {...form.getInputProps('nui')} />
                    <TextInput mt="sm" label={<FormattedMessage id="NrFiscal" defaultMessage="Numri Fiskal" />} placeholder={placeholderTextFiscalNr} {...form.getInputProps('nrFiscal')} />
                </div>
                <div className="inputs-2">
                    <TextInput mt="sm" label={<FormattedMessage id="IdOwner" defaultMessage="ID  e Pronarit / Autorizuesit" />} placeholder={placeholderTextIdOwner} {...form.getInputProps('numriPersonal')} />
                    <div className="select-inputs">
                        <Select
                            searchable
                            clearable
                            allowDeselect
                            label={<FormattedMessage id="MainActivity" defaultMessage="Aktiviteti Kryesor" />}
                            placeholder={placeholderTextDropdown}
                            rightSection={
                                form.values.aktivitetiKryesorId ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            {...form.getInputProps('aktivitetiKryesorId')}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={AktivitetetSelect}
                        />
                        <Select
                            searchable
                            allowDeselect
                            clearable
                            label={<FormattedMessage id="OtherActivity" defaultMessage="Aktivitet Tjera" />}
                            placeholder={placeholderTextDropdown}
                            rightSection={
                                form.values.aktivitetetTjeraId ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            {...form.getInputProps('aktivitetetTjeraId')}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={AktivitetetSelect}
                        />
                    </div>
                </div>

                <Button className="btn-search-slide" type="submit" mt="sm" loading={isLoading}>
                    <FormattedMessage id="Search.name" defaultMessage="Kërko" />
                </Button>
            </form>
        )
    }

    return (
        <div className={`search-slide-section ${location}-slideBox`}>
            {searchBox}
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY_V2}
                size="invisible"
                ref={reCaptchaRef}
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(SearchSlide);
